import { Component, ViewChild, OnDestroy, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CreateExportInterfaceFieldAssignmentTemplateDTO, ExportInterfaceConfigurationType, ExportInterfaceFieldAssignmentDTO, ExportInterfaceFieldAssignmentTemplateDTO } from 'src/app/base/models/models.swagger.generated';
import { ConfigurationsService } from 'src/app/domain/export-configuration/configurations/configurations.service';
import { FieldAssignmentTemplatesOverviewService } from 'src/app/domain/export-configuration/shared/field-assignment-templates-overview/field-assignment-templates-overview.service';
import { FieldAssignmentsFormComponent } from 'src/app/domain/export-configuration/shared/field-assignments-form/field-assignments-form.component';
import { ConfigurationFormCoordinatorService } from '../../configuration-form-coordinator.service';
import { FileFieldsLoadFromTemplateDialogComponent } from './file-fields-load-from-template-dialog/file-fields-load-from-template-dialog.component';
import { FileFieldsSaveAsTemplateDialogComponent } from './file-fields-save-as-template-dialog/file-fields-save-as-template-dialog.component';
import { FieldAssignmentsFormComponent as FieldAssignmentsFormComponent_1 } from '../../../field-assignments-form/field-assignments-form.component';

@Component({
    selector: 'app-configuration-form-file-fields',
    templateUrl: './configuration-form-file-fields.component.html',
    styleUrls: ['./configuration-form-file-fields.component.scss'],
    imports: [
        FieldAssignmentsFormComponent_1,
        FileFieldsLoadFromTemplateDialogComponent,
        FileFieldsSaveAsTemplateDialogComponent,
    ]
})
export class ConfigurationFormFileFieldsComponent implements OnInit, OnDestroy {
  @ViewChild(FieldAssignmentsFormComponent)
  public fieldAssignmentsFormComponent: FieldAssignmentsFormComponent;

  @ViewChild(FileFieldsLoadFromTemplateDialogComponent)
  public loadFromTemplateDialog: FileFieldsLoadFromTemplateDialogComponent;

  @ViewChild(FileFieldsSaveAsTemplateDialogComponent)
  public saveAsTemplateDialog: FileFieldsSaveAsTemplateDialogComponent;

  public get configurationFormFileFields(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormFileFields;
  }

  private subscription: Subscription;

  constructor(
    public configurationFormCoordinatorService: ConfigurationFormCoordinatorService,
    private configurationService: ConfigurationsService,
    private fieldTemplateService: FieldAssignmentTemplatesOverviewService,
  ) { }

  ngOnInit() {
    this.subscription = this.configurationFormCoordinatorService.configurationDetailsDTOUpdated.subscribe(() => {
      this.fieldAssignmentsFormComponent.refresh();
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  public openLoadFromTemplateDialog() {
    this.loadFromTemplateDialog?.show();
  }

  public openSaveAsTemplateDialog() {
    this.saveAsTemplateDialog?.show();
  }

  public templateSelected(template: ExportInterfaceFieldAssignmentTemplateDTO) {
    if (!template) {
      return;
    }
    this.configurationFormCoordinatorService.configurationFormFileFields.setValue({
      assignments: template.assignments.map((a) => {
        const data = new ExportInterfaceFieldAssignmentDTO(a);
        data.id = 0;
        return data;
      }),
    });
    this.fieldAssignmentsFormComponent.refresh();
  }

  public saveAsTemplate(templateName: string) {
    this.fieldTemplateService.createNewTemplate(new CreateExportInterfaceFieldAssignmentTemplateDTO({
      templateName,
      configurationType: this.configurationService.configurationType,
      assignments: this.configurationFormCoordinatorService.configurationFormFileFields.getRawValue()?.assignments?.map(a => new ExportInterfaceFieldAssignmentDTO(a))
    })).subscribe({next: () => {
      // // do nothing
    }, error: (error) => {
      // do nothing
    }});
  }
}
